import leastIndex from "./leastIndex.js";

export default function scan(values, compare) {
  const index = leastIndex(values, compare);
  return index < 0 ? undefined : index;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/scan.js
// module id = 429
// module chunks = 0